<template>
  <div class="card">
    <div class="card-body">
      <transition :name="anim.fadeIn.name" :enter-active-class="anim.fadeIn.enter" :leave-active-class="anim.fadeIn.leave">
        <div v-if="ready">
          <div v-for="haus in bauprojekt_data.extended.hauser" :key="haus.id + haus.name" class="haus_wohnungen_container">
            <div class="default-table-head relative accordion-head" :id="'accordion-head-' + haus.id" @click="toggleAccordion(haus.id)">
              <feather type="home" class="small-icon"></feather>
              <div class="inline-block" style="margin-left:10px;">{{ haus.name }}</div>
              <div class="inline-block amount_wohnungen infra-blue">{{ haus.extended.wohnungen.length }} Wohnungen</div>
              <feather type="edit-2" class="small-icon absolute pointer" style="right:0px;" @click="openModal('edit', haus.id)"></feather>
            </div>
            <div class="accordion-content" :id="'accordion-content-' + haus.id" :class="{ hidden: !isVisible(haus.id) }">
              <div>
                <!-- Start Wohnungen Table -->
                <div class="table-responsive datatable-vue wohnungen-table">
                  <b-table
                    show-empty
                    :items="haus.extended.wohnungen"
                    :fields="tbl_wohnungen_fields"
                    @row-clicked="routeToWohnung"
                    :per-page="pagination[haus.id].perPage"
                    :current-page="pagination[haus.id].currentPage"
                  >
                    <template v-slot:cell(aktionen)="row">
                      <div @click.stop>
                        <router-link :to="bauprojekt_data.id + '/haus/' + haus.id + '/wohnung/' + row.item.id">
                          <feather type="edit-2" class="small-icon tight-icon infra-blue pointer" title="Bearbeiten"></feather>
                        </router-link>

                        <feather
                          type="trash"
                          class="small-icon tight-icon infra-blue pointer"
                          title="Löschen"
                          @click="showDeletionModal(row.item.id)"
                        ></feather>
                      </div>
                    </template>
                    <template slot="empty"><div class="text-center">Keine Einheiten vorhanden.</div></template>
                    <template v-slot:cell(status)="row">
                      <div :class="colorStatus(row.item.status)">{{ row.item.status }}</div>
                    </template>
                  </b-table>
                  <b-col md="6" class="my-1">
                    <b-pagination
                      v-model="pagination[haus.id].currentPage"
                      :total-rows="pagination[haus.id].totalRows"
                      :per-page="pagination[haus.id].perPage"
                      class="my-0"
                    ></b-pagination>
                  </b-col>
                </div>
                <!-- End Wohnungen Table -->
              </div>
              <router-link :to="+bauprojekt_data.id + '/haus/' + haus.id + '/wohnung/neu'" class="einheit_link">
                <b-button>Einheit hinzufügen</b-button>
              </router-link>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <div class="flex-row-end" style="margin-top:30px;">
      <b-button class="btn btn-primary" @click="openModal('create')">Gruppe/Haus hinzufügen</b-button>
    </div>

    <b-modal ref="addHausModal" size="lg" id="addHausModal" cancel-disabled ok-disabled @ok="resetModalValues()">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="card-body">
              <div class="form-container" v-if="modalOpen == 'create'">
                <div class="row">
                  <div class="col-6">
                    <label>Name</label>
                    <b-input-group class="form-input-group" prepend="Abc">
                      <b-form-input
                        class="form-control"
                        name="modal_name"
                        v-model="modal_name"
                        v-bind:class="{ form_error: hasError('modal_name') }"
                      ></b-form-input>
                    </b-input-group>
                    <label>Stellplatz Preis</label>
                    <b-input-group class="form-input-group" prepend="123">
                      <b-form-input
                        class="form-control"
                        v-model="modal_stell_preis"
                        v-bind:class="{ form_error: hasError('modal_stell_preis') }"
                      ></b-form-input>
                    </b-input-group>
                    <label>TG-Stellplatz Preis</label>
                    <b-input-group class="form-input-group" prepend="Abc">
                      <b-form-input
                        class="form-control"
                        v-model="modal_tgstell_preis"
                        prepend="123"
                        v-bind:class="{ form_error: hasError('modal_tgstell_preis') }"
                      ></b-form-input>
                    </b-input-group>
                  </div>
                  <div class="dropzone_container col-6">
                    <label>TG-Stellplatz Plan</label>
                    <vue-dropzone
                      ref="modal_tg_keller_plan"
                      :options="modal_tg_keller_plan_options"
                      id="modal_tg_keller_plan"
                      v-on:vdropzone-file-added="processUploadState"
                      v-on:vdropzone-success="processAsset"                      
                    ></vue-dropzone>
                  </div>
                </div>
              </div>
              <div class="form-container" v-if="modalOpen == 'edit'">
                <div class="row">
                  <div class="col-6">
                    <label>Name</label>
                    <b-input-group class="form-input-group" prepend="Abc">
                      <b-form-input
                        class="form-control"
                        name="modal_name"
                        @blur="processField"
                        v-model="modal_name"
                        v-bind:class="{ form_error: hasError('modal_name') }"
                      ></b-form-input>
                      <feather type="check" v-if="!updating.name" class="checkmark"></feather>
                      <Loader size="20" v-if="updating.name" />
                    </b-input-group>
                    <label>Stellplatz Preis</label>
                    <b-input-group class="form-input-group" prepend="123">
                      <b-form-input
                        class="form-control"
                        v-model="modal_stell_preis"
                        v-bind:class="{ form_error: hasError('modal_stell_preis') }"
                        name="modal_stell_preis"
                        @blur="processField"
                      ></b-form-input>
                      <feather type="check" v-if="!updating.stell_preis" class="checkmark"></feather>
                      <Loader size="20" v-if="updating.stell_preis" />
                    </b-input-group>
                    <label>TG-Stellplatz Preis</label>
                    <b-input-group class="form-input-group" prepend="Abc">
                      <b-form-input
                        class="form-control"
                        v-model="modal_tgstell_preis"
                        prepend="123"
                        v-bind:class="{ form_error: hasError('modal_tgstell_preis') }"
                        name="modal_tgstell_preis"
                        @blur="processField"
                      ></b-form-input>
                      <feather type="check" v-if="!updating.tgstell_preis" class="checkmark"></feather>
                      <Loader size="20" v-if="updating.tgstell_preis" />
                    </b-input-group>
                  </div>
                  <div class="dropzone_container col-6">
                    <label>TG-Stellplatz Plan</label>
                    <div class="image-preview" v-if="!showModalDZ && modal_tg_keller_plan_url" @click="showModalDZ = true">
                      <img :src="modal_tg_keller_plan_url"/>
                    </div>
                    <vue-dropzone
                      ref="modal_tg_keller_plan"
                      :options="modal_tg_keller_plan_options"
                      id="modal_tg_keller_plan"
                      v-on:vdropzone-file-added="processUploadState"
                      v-on:vdropzone-success="processAsset"
                      v-if="showModalDZ"
                    ></vue-dropzone>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template slot="modal-footer">
        <b-button v-if="modalOpen == 'create'" @click="closeModal">Abbrechen</b-button>
        <b-button v-if="modalOpen == 'create'" @click.prevent="createHaus">Erstellen</b-button>
        <b-button v-if="modalOpen == 'edit'" @click="closeModal">OK</b-button>
      </template>
      <template slot="modal-title">
        <div>
          <h4 v-if="modalOpen == 'create'">Haus erstellen</h4>
          <h4 v-if="modalOpen == 'edit'">Haus bearbeiten</h4>
        </div>
      </template>
    </b-modal>
    <b-modal size="s" ref="deleteWohnungModal" id="deleteWohnungModal" cancel-disabled ok-disabled>
      <h5>Wohnung löschen ?</h5>
      <p>Diese Wohnung wird permanent gelöscht.</p>
      <template slot="modal-footer">
        <b-button variant="success" @click="cancelDeletionModal">Abbrechen</b-button>
        <b-button variant="danger" @click="deleteWohnung">Löschen</b-button>
      </template>
      <template slot="modal-header"> </template>
      <template slot="modal-body"> </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import vue2Dropzone from "vue2-dropzone";
import Loader from "@/components/loader.vue";

export default {
  name: "AdminHauser",
  components: {
    vueDropzone: vue2Dropzone,
    Loader: Loader,
  },
  data() {
    return {
      modal_name: "",
      modal_stell_preis: "",
      modal_tgstell_preis: "",
      modal_tg_keller_plan: null,      
      modal_tg_keller_plan_url: "",
      showModalDZ: true, 
      edit_house: false,
      modalOpen: false,
      validation_errors: [],
      active_accordions: [],
      creating: false,
      hauser_data: false,
      bauprojekt_data: false,
      ready: false,
      delete_wohnung: false,
      updating: {
        name: false,
        stell_preis: false,
        tgstell_preis: false,
      },
      tbl_wohnungen_fields: [
        { key: "name", label: "Einheit", sortable: true },
        { key: "etage", label: "Etage(n)", sortable: true },
        { key: "wohnflaeche", label: "Wohnfläche", sortable: true },
        { key: "status", label: "Status", sortable: true },
        { key: "aktionen", label: "Aktionen", sortable: false },
      ],
      tbl_wohnungen_options: {
        totalRows: 1,
        filter: null,
        perPage: 50,
      },
      pagination: {},
      paginationReady: false,
    };
  },
  props: ["bauprojekt_id"],
  created: async function() {
    if (!this.readyState !== undefined && this.readyState.hauser !== undefined) await this.$store.dispatch("app/apiGetHouses");

    //TG Keller Plan dropzone
    this.modal_tg_keller_plan_options = {
      url: this.api.customUploads,
      thumbnailMethod: "contain",
      thumbnailWidth: 250,
      maxFiles: 1,
      init: function() {
        this.on("maxfilesexceeded", function(file) {
          this.removeAllFiles();
          this.addFile(file);
        });
      },
      dictDefaultMessage:
        '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-upload-cloud"><polyline points="16 16 12 12 8 16"></polyline><line x1="12" y1="12" x2="12" y2="21"></line><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"></path><polyline points="16 16 12 12 8 16"></polyline></svg>',

      headers: {
        Authorization: "bearer " + await this.$directus.auth.token,
        "Cache-Control": null,
        "X-Requested-With": null,
      },
    };

    this.getBauprojektState();
    this.initPagination();
    this.original = [];
    this.ready = true;
  },
  computed: {
    ...mapGetters({
      bauprojekte: "app/bauprojekte",
      hauser: "app/hauser",
      readyState: "app/readyState",
      anim: "app/animations",
      api: "auth/apiSettings",
      toast: "app/toasts",
    }),
  },
  methods: {
    initPagination() {
      let paginationObj = {};
      this.bauprojekt_data.extended.hauser.forEach((haus) => {
        const pageProps = {
          id: haus.id,
          totalRows: haus.extended.wohnungen.length,
          currentPage: 1,
          perPage: 25,
        };

        paginationObj[haus.id] = pageProps;
      });

      this.pagination = Object.assign({}, paginationObj);
    },
    isVisible(accordID) {
      return this.active_accordions.indexOf(accordID) > -1 ? true : false;
    },
    toggleAccordion(accordID) {
      const index = this.active_accordions.indexOf(accordID);
      const isOpen = index > -1 ? true : false;
      if (isOpen) {
        this.active_accordions.splice(index, 1);
        return;
      }
      this.active_accordions.push(accordID);
    },
    getBauprojektState() {
      const bauprojekt = this.bauprojekte.find((bp) => bp.id == this.$route.params.bauprojekt_id);
      this.bauprojekt_data = bauprojekt;
    },
    showDeletionModal(wohnung_id) {
      this.delete_wohnung = wohnung_id;
      this.$refs["deleteWohnungModal"].show();
    },
    cancelDeletionModal() {
      this.delete_wohnung = false;
      this.$refs["deleteWohnungModal"].hide();
    },
    async deleteWohnung() {
      this.$store.dispatch("app/removeWohnung", this.delete_wohnung);
      this.$refs["deleteWohnungModal"].hide();
    },
    async createHaus() {
      //validate all needed fields

      await this.validate("modal_name");
      if (this.validation_errors.length > 0) {
        return;
      }

      //create Haus Payload
      const hausPayload = {
        name: this.modal_name,
        haus_bp: this.bauprojekt_data.id,
        stell_preis: this.modal_stell_preis,
        tgstell_preis: this.modal_tgstell_preis,
        tg_keller_plan: this.modal_tg_keller_plan  == "" ? null : this.modal_tg_keller_plan,
        status: "published",
      };

      try {
        this.creating = true;
        await this.$store.dispatch("app/addHaus", hausPayload);
        const updateSinglePayload = {
          resource: "bauprojekt",
          id: this.bauprojekt_data.id,
        };
        await this.$store.dispatch("app/updateSingle", updateSinglePayload);
        await this.$store.dispatch("app/apiGetHouses");
        this.getBauprojektState();
        this.initPagination();
        this.closeModal();
        this.resetModalValues();
      } catch (error) {
        console.log(error);
        this.$toasted.show("Fehler beim Erstellen des Hauses.", this.toast.failure);
      } finally {
        this.creating = false;
      }
    },
    async processField(field) {
      const changedField = field.target.name.split("modal_")[1];
      const changed = this.original[changedField] !== this["modal_" + changedField];
      if (!changed) {
        const errorVisible = this.validation_errors.indexOf(changedField);
        if (errorVisible > -1) this.validation_errors.splice(errorVisible, 1);
        return;
      }

      //if changed, validate
      await this.validate(field.target.name);
      if (this.validation_errors.length > 0) {
        return;
      }

      let changedData = {};
      changedData[changedField] = this["modal_" + changedField];
      this.updating[changedField] = true;

      try {
        await this.$directus.items("haus").updateOne(this.edit_house.id, changedData);
        await this.$store.dispatch("app/updateSingle", {
          resource: "haus",
          id: this.edit_house.id,
        });
        this.updating[changedField] = false;
        this.original[changedField];
      } catch (error) {
        this.$toasted.show("Error Updating Field", this.toast.failure);
      }
    },
    async validate(field) {
      const fieldName = field;
      const errorExists = this.validation_errors.indexOf(fieldName);
      if (errorExists > -1) this.validation_errors.splice(errorExists, 1);

      const validationPayload = {
        context: "haus",
        field: fieldName.indexOf("modal_" > -1) ? fieldName.split("modal_")[1] : fieldName,
        value: this[fieldName],
      };

      const validation_result = await this.$store.dispatch("app/validateField", validationPayload);
      if (!validation_result) this.validation_errors.push(fieldName);
    },
    hasError(field) {
      return this.validation_errors.indexOf(field) > -1 ? true : false;
    },
    processUploadState(thing, thing2) {
      console.log(thing);
      console.log(thing2);
      return true;
    },
    async processAsset(response = null, data = null) {
      //handle error / success of upload
      if (!response.xhr.status == 200) {
        this.$toasted.show("Fehler beim Upload", this.toast.error);
        return;
      }
      this.$toasted.show(data.data.filename_download + " Datum.", this.toast.success);

      //check what type of asset was uploaded
      const asset_type = response.previewElement.parentNode.id.split("modal_")[1];

      //tag the item in directus with the correct asset type
      /*
      try {
        await this.$directus.updateItem("directus_files", data.data.id, {
          tags: [asset_type, "draft"],
        });
      } catch (error) {
        this.$toasted.show("Error uploading Image", this.toast.failed);
      }
      */

      this["modal_" + asset_type] = data.data.id;

      if (this.modalOpen == "edit") {
        try {
          const payload = {
            collection: "haus",
            item: this.edit_house.id,
            changes: {
              tg_keller_plan: data.data.id,
            },
          };

          const updatePayload = {
            resource: "haus",
            id: this.edit_house.id,
          };
          await this.$store.dispatch("app/mutate", payload);
          await this.$store.dispatch("app/updateSingle", updatePayload);

          this.edit_house = false;
        } catch (error) {
          this.$toasted.show("Error assigning the Image to the House. ", this.toast.failure);
        }
      }
      return true;
    },
    resetModalValues() {
      console.log("resetModalValues is running")
      this.modal_name = "",
      this.modal_stell_preis = "",
      this.modal_tgstell_preis = "",
      this.modal_tg_keller_plan = "",
      this.modal_tg_keller_plan_url = "";
      this.modalCreateOpen = false,
      this.validation_errors = [],
      this.creating = false;
      this.original = [];
    },
    async openModal(mode, id = null) {
      if (mode == "create") {
        this.modalOpen = "create";
        this.modal_name = "";
        this.modal_stell_preis = "";
        this.modal_tgstell_preis = "";
        this.modal_tg_keller_plan = "";
        this.modal_tg_keller_plan_url = "";
      }

      if (mode == "edit") {
        this.modalOpen = "edit";
        this.edit_house = this.hauser.find((haus) => haus.id == id);

        this.modal_name = this.edit_house.name;
        this.modal_stell_preis = this.edit_house.stell_preis;
        this.modal_tgstell_preis = this.edit_house.tgstell_preis;
        this.modal_tg_keller_plan = this.edit_house.tg_keller_plan;        

        //original values
        this.original.name = this.edit_house.name;
        this.original.stell_preis = this.edit_house.stell_preis;
        this.original.tgstell_preis = this.edit_house.tgstell_preis;

        if (
          "undefined" !== typeof this.edit_house.tg_keller_plan &&
          this.edit_house.tg_keller_plan !== null &&
          this.edit_house.tg_keller_plan != ""
        ) {
          await this.assignExistingImage(this.edit_house.tg_keller_plan);
        }
      }
      this.$bvModal.show("addHausModal");
    },
    async assignExistingImage(imageID) {
      console.log("assignExistingImg running for ID " + imageID);
      this.showModalDZ = false;

      const imgQuery = {
        id: imageID,
        format: "thumb-400-full",
        mode: "imgtag",
        volatile: true
      }

      const imgURL = await this.$store.dispatch("images/getImgURL", imgQuery);

      this.modal_tg_keller_plan_url = imgURL.url;
    },
    closeModal() {
      this.modalOpen = false;
      this.$bvModal.hide("addHausModal");
    },
    colorStatus(status) {
      switch (status) {
        case "reserviert":
          return "orange";
        case "verkauft":
          return "red";
        case "verfügbar":
          return "green";
      }
    },
    routeToWohnung(record) {
      this.$router.push("/admin/dashboard/bauprojekte/" + this.bauprojekt_data.id + "/haus/" + record.haus + "/wohnung/" + record.id);
    },
  },
};
</script>

<style>
.accordion-head {
  cursor: pointer;
}

.amount_wohnungen {
  font-size: 0.7em;
  position: relative;
  left: 20px;
}

.debuggy {
  margin-left: 10px;
  color: green;
}

.haus_wohnungen_container {
  margin: 35px 0;
}

#modal_tg_keller_plan {
  position: relative !important;
}

#modal_tg_keller_plan .dz-default.dz-message {
  display: flex;
  justify-content: center;
  width: 100% !important;
}

#modal_tg_keller_plan .dz-default.dz-message span {
  align-self: center;
}

.wohnungen-table tr {
  cursor: pointer;
}
</style>

<style scoped>
.form-group {
  position: relative;
}

.checkmark {
  color: green;
}

.failmark {
  color: red;
}

.loader {
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  -moz-backdrop-filter: none;
}
.loader,
.checkmark,
.failmark {
  position: absolute;
  bottom: 7px;
  right: 10px;
  display: block;
  height: 20px;
  width: 20px;
}

.checkmark.select,
.loader.select {
  right: 30px;
  z-index: 1000;
}
a.einheit_link i {
  margin-right: 5px;
  margin-left: 0;
}
a.einheit_link {
  display: flex;
}
</style>

<style scoped>
.red {
  color: red;
}

.green {
  color: green;
}

.orange {
  color: orange;
}
</style>
